<app-modal [dismissable]="true" [title]="'Clinic Details' | translate">
  <div ngbAutoFocus class="modal-content pt-0" style="height: 70vh; overflow-y: auto;">

    <!-- destroyOnHide=false: every tab is rendered up front so the formly rules of all tabs gate Save -->
    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" [destroyOnHide]="false" class="nav-tabs">
      <li [ngbNavItem]="'cover'">
        <button ngbNavLink>Cover</button>
        <ng-template ngbNavContent>
          <div class="tab-content-wrapper py-3">
            <div class="cover-upload-container">
              <label class="form-label fw-bold">Cover Image</label>

              <div class="current-cover mb-3" *ngIf="currentCoverUrl && !newCoverPreview">
                <div class="position-relative cover-image-wrapper">
                  <img [src]="currentCoverUrl" alt="Current cover" class="img-fluid rounded w-100"
                    style="max-height: 400px; object-fit: contain;">

                </div>
              </div>

              <div class="new-cover-preview mb-3" *ngIf="newCoverPreview">
                <div class="position-relative cover-image-wrapper">
                  <img [src]="newCoverPreview" alt="New cover preview" class="img-fluid rounded w-100"
                    style="max-height: 400px; object-fit: contain;">
                  <button type="button" class="btn-remove-cover" (click)="cancelNewCover()" title="Cancel new cover">
                    <i class="ti ti-x"></i>
                  </button>
                </div>
              </div>

              <div class="upload-area">
                <input type="file" #fileInput accept="image/*" (change)="onFileSelected($event)" class="d-none">

                <div class="upload-placeholder border border-2 border-dashed rounded p-5 text-center"
                  (click)="fileInput.click()" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                  (drop)="onDrop($event)" [class.drag-over]="isDragOver" style="cursor: pointer; transition: all 0.3s;">
                  <i class="ti ti-cloud-upload" style="font-size: 48px;" class="text-muted mb-2"></i>
                  <p class="mb-1">
                    <strong>Click to upload</strong> or drag and drop
                  </p>
                  <p class="text-muted small mb-0">PNG, JPG, JPEG (max 5MB)</p>
                </div>
              </div>

              <div class="text-danger mt-2" *ngIf="uploadError">
                {{ uploadError }}
              </div>
            </div>
          </div>
        </ng-template>
      </li>
      <li [ngbNavItem]="'socials'">
        <button ngbNavLink [class.text-danger]="socialsInvalid">Socials <i *ngIf="socialsInvalid" class="ti ti-alert-circle"></i></button>
        <ng-template ngbNavContent>
          <div class="tab-content-wrapper py-3">
            <form [formGroup]="updateForm">
              <formly-form [form]="updateForm" [fields]="socialFields" [model]="updateModel">
              </formly-form>
            </form>
          </div>
        </ng-template>
      </li>
      <li [ngbNavItem]="'languages'">
        <button ngbNavLink [class.text-danger]="languagesInvalid">{{ 'Languages' | translate }} <i *ngIf="languagesInvalid" class="ti ti-alert-circle"></i></button>
        <ng-template ngbNavContent>
          <div class="tab-content-wrapper py-3">
            <form [formGroup]="updateForm">
              <formly-form [form]="updateForm" [fields]="languageFields" [model]="updateModel">
              </formly-form>
            </form>
          </div>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
  </div>
  <div class="modal-actions w-100 d-flex align-items-center justify-content-end gap-2 h-100">
    <app-button type="button" buttonType="light" (onClick)="activeModal.dismiss('cancel')"
      label="{{ 'Cancel' | translate }}">
    </app-button>
    <app-button type="button" (onClick)="submit()" [isDisabled]="!updateForm.valid || isSubmitting"
      label="{{ 'Save Changes' | translate }}">
    </app-button>
  </div>
  <ngx-spinner bdColor="rgba(51,51,51,0.8)">
    <span class="spinner-border spinner-border-lg me-2 text-muted-light" role="status" aria-hidden="true"></span>
  </ngx-spinner>
</app-modal>
